import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { OrganizationService } from "../../../modules/shared/Services/organization.service";
import { Organization } from "../../../models/organization";
import { BehaviorSubject, retry } from "rxjs";
import { first } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class FetchUserDataOnDashboardService {
    apiBaseUrl = environment.apiBaseUrl;
    userOrganisations: BehaviorSubject<Organization[]> = new BehaviorSubject<Organization[]>([]);
    userOrganisations$ = this.userOrganisations.asObservable();

    constructor(private orgService: OrganizationService) {}

    storeUserOrganisations() {
        this.orgService
            .getUserOrganizationList()
            .pipe(first(), retry(3))
            .subscribe({
                next: (res) => {
                    this.userOrganisations.next(res.data);
                },
                error: (err) => {
                    this.userOrganisations.next([]);
                },
            });
    }

    getUserOrganisationsFromSessionStorage() {
        return this.userOrganisations.getValue();
    }
}
